/**
 * The rows a school sheet and the route sheet repeat at the top of each
 * printed page, through their table's `<thead>` (browsers repeat a header
 * group on every page; see `lib/chefs/print-identity.ts`):
 *
 *   OLHSA Pontiac Main Building                                  Page 25 of 33
 *   Stop 1 · Unload 8:55 AM · Window 7:00 to 9:00 AM
 *   Oakland Livingston Human Service Agency · 196 Cesar E Chavez, Pontiac, MI 48342
 *   Orders · Jeff's Over the Top Catering · Deliveries Fri, Sep 25 · Printed Fri, Sep 25, 3:57 PM
 *   [ DRY RUN: DO NOT DELIVER ]
 *
 * The stop leads, because a sheet belongs to a stop's pile, and its place on
 * the route comes next (Abner, Sep 25: the sheets follow the drive); the
 * packet, the kitchen, the day and the print time say which printout it came
 * from.
 */

import { PrintHeaderNotice } from '@/components/print/print-header'

/** Secondary text on paper: the make list's and the ingredient table's. */
export const PRINT_SECONDARY = 'text-[9pt] text-[#444]'

export function PrintSheetHeading({
  title,
  stopLine,
  detail,
  subheading,
  warning,
  colSpan,
}: {
  /** The stop: a school's name, or "Delivery route". */
  title: string
  /** The school's place on the route: "Stop 2 · Unload 8:55 AM · Window 7:00 to 9:00 AM". */
  stopLine?: string | null
  /** Where the stop is: the organization and the address. */
  detail?: string | null
  /** `sheetPrintSubheading(...)`: the packet, the kitchen, the day, the print time. */
  subheading: string
  /** A line nobody may miss on any page ("Dry run: do not deliver"). */
  warning?: string | null
  colSpan: number
}) {
  return (
    <>
      <tr>
        <th colSpan={colSpan} className="pb-0.5 text-left text-[13pt] font-semibold leading-tight">
          {title}
        </th>
      </tr>
      {stopLine ? (
        <tr>
          <th colSpan={colSpan} className="text-left font-medium">
            {stopLine}
          </th>
        </tr>
      ) : null}
      {detail ? (
        <tr>
          <th colSpan={colSpan} className={`text-left font-normal ${PRINT_SECONDARY}`}>
            {detail}
          </th>
        </tr>
      ) : null}
      <tr>
        <th colSpan={colSpan} className={`text-left font-normal ${PRINT_SECONDARY} ${warning ? '' : 'pb-2'}`}>
          {subheading}
          <PrintHeaderNotice className="ml-2 inline-block align-middle" />
        </th>
      </tr>
      {warning ? (
        <tr>
          <th colSpan={colSpan} className="pb-2 pt-1 text-left">
            <span className="inline-block border border-black px-1.5 py-0.5 text-[9pt] font-semibold uppercase tracking-wide">
              {warning}
            </span>
          </th>
        </tr>
      ) : null}
    </>
  )
}
